import Vue from 'vue'
import Router from 'vue-router'

/*
* Pagine
*/
import HomePage from './views/HomePage.vue'
import LoginPage from './views/LoginPage.vue'
import ProfilePage from './views/ProfilePage.vue'
import ServicesPage from './views/ServicesPage.vue'
import LocalBusPage from './views/LocalBusPage.vue'
import MyTicketPage from './views/MyTicketPage.vue'
import DoorToDoorPage from './views/DoorToDoorPage.vue'
import DoorToDoorBookPage from './views/DoorToDoorBookPage.vue'
import AboutPage from './views/AboutPage.vue'
import ThankyouPage from './views/ThankyouPage.vue'

//import store from './store';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'doortodoor',
      //component: () => import(/* webpack   ChunkName: "home" */ HomePage)
      component: DoorToDoorPage
    }
    ,
    {
      path: '/transfer',
      name: 'transfer',
      //component: () => import(/* webpack   ChunkName: "home" */ HomePage)
      component: HomePage
    }
    ,
    {
      path: '/local-bus',
      name: 'localbus',
      //component: () => import(/* webpack   ChunkName: "home" */ HomePage)
      component: LocalBusPage
    }
    ,

    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfilePage
    },
    {
      path: '/myticket',
      name: 'myticket',
      component: MyTicketPage
    },
    {
      path: '/services',
      name: 'services',
      component: ServicesPage
    },
    {
      path: '/doortodoor',
      name: 'doortodoor',
      component: DoorToDoorPage
    }
    ,
    {
      path: '/doortodoor/book',
      name: 'doortodoorbook',
      component: DoorToDoorBookPage
    }
    ,
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: ThankyouPage
    }
    
  ]
  
})
